import { GlLoadingIcon } from '../../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { s__, sprintf } from '~/locale';
import { DEBOUNCE_DELAY } from '~/vue_shared/components/filtered_search_bar/constants';
import searchProjectsQueryWithDashboards from './graphql/search_projects_with_dashboards.query.graphql';
import searchGroupsQueryWithDashboards from './graphql/search_groups_with_dashboards.query.graphql';
import DashboardItemsList from './dashboard_items_list.vue?vue3';
import { hasDashboard } from './utils';
export default {
    name: 'DashboardSearchResults',
    components: {
        GlLoadingIcon,
        DashboardItemsList
    },
    props: {
        searchTerm: {
            type: String,
            required: true
        },
        dashboardName: {
            type: String,
            required: true
        }
    },
    apollo: {
        projects: {
            debounce: DEBOUNCE_DELAY,
            query: searchProjectsQueryWithDashboards,
            variables () {
                return {
                    search: this.searchTerm
                };
            },
            skip () {
                return !this.searchTerm || this.notEnoughCharacters;
            },
            update (data) {
                return data?.projects?.nodes?.filter((project)=>hasDashboard(project, this.dashboardName)) || [];
            }
        },
        groups: {
            debounce: DEBOUNCE_DELAY,
            query: searchGroupsQueryWithDashboards,
            variables () {
                return {
                    search: this.searchTerm
                };
            },
            skip () {
                return !this.searchTerm || this.notEnoughCharacters;
            },
            update (data) {
                return data?.currentUser?.groups?.nodes?.filter((group)=>hasDashboard(group, this.dashboardName)) || [];
            }
        }
    },
    data () {
        return {
            projects: [],
            groups: []
        };
    },
    computed: {
        notEnoughCharacters () {
            return this.searchTerm.length < 2;
        },
        loading () {
            return this.$apollo.queries.projects.loading || this.$apollo.queries.groups.loading;
        },
        formattedProjects () {
            return this.projects.map((project)=>({
                    id: project.id,
                    name: project.name,
                    namespace: project.nameWithNamespace,
                    avatarUrl: project.avatarUrl,
                    fullPath: project.fullPath
                }));
        },
        formattedGroups () {
            return this.groups.map((group)=>({
                    id: group.id,
                    name: group.name,
                    namespace: group.fullName,
                    avatarUrl: group.avatarUrl,
                    fullPath: group.fullPath
                }));
        },
        hasResults () {
            return this.projects.length > 0 || this.groups.length > 0;
        },
        showNoResults () {
            return !this.loading && !this.hasResults && this.searchTerm.length >= 2;
        },
        searchStatus () {
            if (this.loading) {
                return s__('Dashboards|Searching for groups and projects');
            }
            if (this.notEnoughCharacters) {
                return this.$options.i18n.minCharacters;
            }
            if (this.showNoResults) {
                return this.$options.i18n.noResults;
            }
            if (this.formattedProjects.length || this.formattedGroups.length) {
                return sprintf(s__('Dashboards|Search found %{groups} groups and %{projects} projects'), {
                    groups: this.formattedGroups.length,
                    projects: this.formattedProjects.length
                });
            }
            return '';
        }
    },
    i18n: {
        noResults: s__('Dashboards|No projects or groups found'),
        minCharacters: s__('Dashboards|Type at least 2 characters to search')
    }
};
